import React from "react";
import { TextInputField, DropDownField} from "../../../helpers";
import { calculateBuyerQuotation, logisticHSNOptions } from "../../../utils";
import { Tooltip } from "primereact/tooltip";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

const LogisticCharge = (props) => {
    const { buyerQuote, buyerQuoteItems, setBuyerQuote, HSNMasterData, approvalRequestStatusDetails, quotationApprovals } = props

    const LogisticOptions=[
        {value:"Free Delivery"},
        {value:"Delivery At Actuals"},
        {value:"Delivery Charges Extra"},
    ]

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)


    let gstRates = pmCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), value: eachGSTRate}))


    const handleBuyerQuoteChange = (event) => {
        buyerQuote[event.target.name] = event.target.value

        if(event.target.name === "bQuotLogisticsHSN"){
            const relatedHSNCodes = HSNMasterData.filter(eachHSN => eachHSN.HSNCode === event.target.value)
            const hsnGSTOptions = relatedHSNCodes.map(eachHSN => eachHSN.GSTRate)
            buyerQuote.logisticsGSTRateOptions = [buyerQuote.bQuotLogisticsGSTRate, ...hsnGSTOptions]
        }

        const calculatedResult = calculateBuyerQuotation(buyerQuote, buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }


    const updatedGSTOptions = gstOptions.filter(eachGST => {
        return buyerQuote?.logisticsGSTRateOptions?.includes(eachGST.value)
    })

    // const relatedReqStatus = approvalRequestStatusDetails.find(eachApprovalReq => eachApprovalReq.requestStatus && eachApprovalReq.approvalId === 11)

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed
    return(
        <div>
            <div><h5 className="text-600 mb-1">Logistic Charge</h5> </div>
            <div className="p-card mb-0">
                <div className="grid flex-row align-items-center">
                    <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                        <DropDownField name="bQuoteLogisticsOption" labelText='Logistic Options' onChange={handleBuyerQuoteChange} value={buyerQuote.bQuoteLogisticsOption} options={LogisticOptions} optionLabel="value" />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                        {/* <TextInputField name="bQuotLogisticsBeforeTax" labelText='Log. charge' value={buyerQuote.bQuotLogisticsBeforeTax} onChange={handleBuyerQuoteChange} keyfilter={"pnum"} /> */}
                        <TextInputField name="bQuotLogisticsBeforeTax" labelText='Log. charge' value={buyerQuote.bQuotLogisticsBeforeTax} keyfilter="num" onChange={handleBuyerQuoteChange} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <TextInputField name="" labelText='Specification' value={buyerQuote.bQuoteLogisticsOption} disabled={buyerQuote.bQuoteLogisticsOption !== "Delivery Charges Extra"} />
                    </div>
                    {/* <div className="flex flex-column  col-12 mb-2 lg:col-1 lg:mb-0">
                        <TextInputField name="bQuotLogisticsHSN" labelText='HSN' value={buyerQuote.bQuotLogisticsHSN} onChange={handleBuyerQuoteChange} />
                    </div> */}
                    {
                        isHSNEntryAllowed ?
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                            <DropDownField name="bQuotLogisticsHSN" labelText="HSN" value={buyerQuote.bQuotLogisticsHSN} options={logisticHSNOptions} onChange={handleBuyerQuoteChange} />
                        </div>
                        :
                        null
                    }
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                        <DropDownField name="bQuotLogisticsGSTRate" labelText={pmCompanyConfig.GSTRateLabel} value={buyerQuote.bQuotLogisticsGSTRate} options={updatedGSTOptions} onChange={handleBuyerQuoteChange} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                        <TextInputField name="logisticsTaxAmount" labelText='Tax Amount' value={buyerQuote.logisticsTaxAmount} disabled />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                        <TextInputField name="productName" labelText='Total Logistic' value={buyerQuote.bQuotLogisticsWithTax} disabled />
                    </div>
                    {/* {
                        relatedReqStatus ?
                        <div className="ml-4">
                            <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png" className="logistic-approval-btn-tooltip tooltip cursor-auto" style={{ height: "30px", width: "30px" }} />
                            <Tooltip target={'.logistic-approval-btn-tooltip'} position='top' style={{ width: "200px" }}>
                                <div className="w-100 flex flex-column">
                                    <p className="m-0" >Logistics GST override needs approval!</p>
                                </div>
                            </Tooltip>
                        </div> : null
                    } */}
                </div>
                <p style={{fontSize: '13px', margin: 0}}>Total Seller Logistics: {buyerQuote.totalSellerLogistics}</p>
            </div>
        </div>
    )
}

export default LogisticCharge;